"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllSeismicData = exports.querySeismicZones = void 0;
const core_1 = require("@natomas-org/core");
const index_1 = require("../index");
const querySeismicZones = async (request, layerType) => {
    return (0, index_1.queryPublicArcGIS)(layerType, request, "*").then((response) => {
        var _a, _b;
        const responseArray = (_b = (_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.map((feature) => feature === null || feature === void 0 ? void 0 : feature.properties)) !== null && _b !== void 0 ? _b : null;
        return responseArray && responseArray.length > 0;
    });
};
exports.querySeismicZones = querySeismicZones;
const getAllSeismicData = async (request) => {
    return (0, index_1.queryPublicArcGIS)(core_1.SEISMIC_PARCEl_GIS_LAYER_URL, request, "LandslideZone,LiquefactionZone,FaultZone", false).then((response) => {
        var _a, _b;
        if (!response || ((_a = response.features) === null || _a === void 0 ? void 0 : _a.length) < 1) {
            return null;
        }
        const properties = (_b = response === null || response === void 0 ? void 0 : response.features[0]) === null || _b === void 0 ? void 0 : _b.properties;
        let landslideZone;
        let liquefactionZone;
        let faultZone;
        switch (Number(properties["LandslideZone"])) {
            case 1:
                landslideZone = true;
                // "All or a portion of this parcel LIES WITHIN a Landslide Zone.";
                break;
            case 2:
                landslideZone = false; //  "This parcel is NOT WITHIN a Landslide Zone.";
                break;
            case 3:
                landslideZone = null;
                //  "Not all of this parcel has been evaluated by CGS for landslide hazards.";
                break;
            case 4:
                landslideZone = null;
                //  "This parcel has NOT been EVALUATED by CGS for seismic landslide hazards.";
                break;
        }
        switch (Number(properties["LiquefactionZone"])) {
            case 1:
                liquefactionZone = true;
                //  "All or a portion of this parcel LIES WITHIN a Liquefaction Zone.";
                break;
            case 2:
                landslideZone = false; // "This parcel is NOT WITHIN a Liquefaction Zone.";
                break;
            case 3:
                landslideZone = null;
                //  "Not all of this parcel has been evaluated by CGS for liquefaction hazards.";
                break;
            case 4:
                landslideZone = null;
                //  "This parcel has NOT been EVALUATED by CGS for liquefaction hazards.";
                break;
        }
        switch (Number(properties["FaultZone"])) {
            case 1:
                faultZone = false; //  "This parcel is NOT WITHIN an Earthquake Fault Zone.";
                break;
            case 2:
                faultZone = true;
                // "All or a portion of this parcel LIES WITHIN an Earthquake Fault Zone.";
                break;
        }
        return {
            FaultZone: faultZone,
            LiquefactionZone: liquefactionZone,
            LandslideZone: landslideZone,
        };
    });
};
exports.getAllSeismicData = getAllSeismicData;
//# sourceMappingURL=seismic.js.map